import React, { createRef, ReactElement, ReactNode, useEffect, useRef, useState } from 'react';
import Suspense from '../Suspense';

interface IViewportLoader {
  children: ReactNode;
  loader?: ReactElement | null;
}

const ViewportLoader = ({ children, loader = null }: IViewportLoader) => {
  const target = createRef<HTMLDivElement>();
  const [visible, setVisible] = useState(false);

  const observer = useRef<IntersectionObserver>(
    new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          if (target.current) {
            observer.current.unobserve(target.current);
          }
          setVisible(true);
        }
      },
      { root: null, rootMargin: '0px', threshold: 0 },
    ),
  );

  useEffect(() => {
    if (target.current && observer.current) {
      observer.current.observe(target.current);
    }

    return () => {
      if (target.current) {
        observer.current.unobserve(target.current);
      }
    };
  }, [target.current]);

  return (
    <div ref={target} suppressHydrationWarning>
      {!visible && loader}
      {visible && <Suspense fallback={loader}>{children}</Suspense>}
    </div>
  );
};

export default ViewportLoader;
